module.exports = __webpack_public_path__ + "static/media/chuva.45503e59.jpg";